import api from 'api-client'

// Agency passthrough reduces the arrangement fee; the gross value stays available
// as arrangement_fee_gross for reports that need the unreduced figure.
const applyAgencyPassthrough = (item) => {
    item.arrangement_fee_gross = Number(item.arrangement_fee || 0)
    item.arrangement_fee = item.arrangement_fee_gross - Number(item.agency_value || 0)
    return item
}

const state = {
    reportingData: [],
    lastSeasonReportingData: []
}

const getters = {
    reportingData: state => state.reportingData,
    lastSeasonReportingData: state => state.lastSeasonReportingData,
    eventGroupsForCurrentSeason: state => {
        const result = []
        const eventGroupsRaw = state.reportingData
            .map(i => ({id: i.event_group_id, name: i.event_group_name, countryCode: i.event_country }))

        eventGroupsRaw.forEach(ev => {
            if (!result.find(e => e.id === ev.id)) {
                result.push(ev)
            }
        })
        const extractPrefixNumber = (name) => {
            if (!name || typeof name !== 'string') return Number.POSITIVE_INFINITY
            const match = name.trim().match(/^(\d+)/)
            return match ? parseInt(match[1], 10) : Number.POSITIVE_INFINITY
        }

        return result.sort((a, b) => {
            const numA = extractPrefixNumber(a.name)
            const numB = extractPrefixNumber(b.name)
            if (numA !== numB) return numA - numB
            if (a.name < b.name) return -1
            if (a.name > b.name) return 1
            return 0
        })

    }
}

const mutations = {
    setReportingData (state, reportingData, t) {
        state.reportingData = reportingData
    },
    setLastSeasonReportingData (state, reportingData) {
        state.lastSeasonReportingData = reportingData
    }
}

const actions = {
    loadReportingData ({ commit, rootState }, seasonId) {
        return api.findReportingData(seasonId)
            // Prepare data for VAT
            .then(result => {
                if (rootState.auth.user.showVAT) {
                    return result.map(item => {
                        if (item.is_contractual) {
                            item.costs = item.costs_vat
                            item.costs_total = item.costs_total_vat
                        }
                        return item
                    })
                }
                return result
            })
            // Set agency name
            .then(result => {
                return result.map(item => {
                    if (item.AgencyName) {
                        item.wo_partner_name = item.AgencyName
                    }
                    return item
                })
            })
            // cast dates
            .then(results => {
                return results.map(item => {
                    item.wo_date = new Date(item.wo_date)
                    return item
                })
            })
            .then(results => results.map(applyAgencyPassthrough))
            .then(result => commit('setReportingData', result))
    },
    refreshReportingData ({ dispatch, rootState }) {
        console.log('have to reload')
        const seasonId = rootState.settings.season
        dispatch('loadReportingData', seasonId)

    },
    loadReportingDataLastSeason (state, seasonId) {
        return api.findReportingData(seasonId)
            // cast dates
            .then(results => {
                return results.map(item => {
                    item.wo_date = new Date(item.wo_date)
                    return item
                })
            })
            .then(results => results.map(applyAgencyPassthrough))
            .then(result => state.commit('setLastSeasonReportingData', result))
    },
    loadReportingDataComplete (state) {
        return api.findReportingData()
            .then(results => results.map(applyAgencyPassthrough))
    },
    recreateReportingCache () {
        return api.recreateReportingCache()
    }
}

export default {
    state, getters, mutations, actions
}
